import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
// -
import NavBreadcrumb from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "../utils/buttonsActions";
import TableHistory from "./history/TableHistory";
import HistoryFilters from "./history/HistoryFilters";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";

const buttonsActions = new ButtonsActions();

const ViewHistory = () => {
    const {t: _Tr} = useTranslation("routes");
    const [buttonsTB, setButtonsTB] = useState({...buttonsActions});
    const title = _Tr("labels.history");
    const bread = [
        {name: _Tr("labels.history"), url: "/historic/", current: false},
        {name: title, current: true},
    ];

    const items = useRef(new ItemsModel());
    const [itemsShown, setItemsShown] = useState([]);
    const filters = useRef(new FilterModel());
    const [loading, setLoading] = useState(true);
    const pagerModelRef = useRef(new PagerModel());

    useEffect(() => {
        const buttons = {...buttonsActions};
        buttons.title = title;
        setButtonsTB({...buttons});
        pagerModelRef.current.handleCallApi = fetchHistory;
        filters.current.filter = (e) => {
            pagerModelRef.current.paging.page = 1;
            fetchHistory();
        };
        const fetchGetHistory = async () => {
            setLoading(true);
            try {
                const resp = await axiApi.get("/api/loggers/actions/");
                if (resp.data && resp.data.status) {
                    items.current.all = resp.data.items || [];
                    items.current.showed = resp.data.items || [];
                    setItemsShown(resp.data.items || []);
                    pagerModelRef.current.paging.setPager(resp.data);
                    pagerModelRef.current.active = resp.data.items.length > 0;
                }
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchGetHistory();
    }, []);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const resp = await axiApi.post(
                "/api/loggers/actions/",
                filters.current.chosen,
                {
                    params: pagerModelRef.current.paging.getParams(),
                }
            );
            if (resp.data && resp.data.status) {
                items.current.all = resp.data.items || [];
                items.current.showed = resp.data.items || [];
                setItemsShown(resp.data.items || []);
                pagerModelRef.current.paging.setPager(resp.data);
                pagerModelRef.current.active = resp.data.items.length > 0;
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <NavBreadcrumb bread={bread} navs={navs} />
            <TopBarActions actions={buttonsTB} title={title} />
            <HistoryFilters filtersRef={filters} />
            <TopBarPagination
                pagerModel={pagerModelRef.current}
                stickyTopValue="125px"
                showSelect={false}
            />
            <LoaderSpinner isLoading={loading}>
                <TableHistory itemsShown={itemsShown} />
            </LoaderSpinner>
        </>
    );
};

export default ViewHistory;
